// protobuf 文件参考:
// - https://developers.google.com/protocol-buffers/

// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file product_without_validate.proto (package trpc.teg_devops.servicedesk_product, syntax proto3)
/* eslint-disable */
// @ts-nocheck

// package分成三级 trpc.app.server，app是一个业务项目分类，server是具体的进程服务名

import { AddScheduleReq, AddScheduleRsp, AddTemplateRep, AddTemplateRsp, AppendUserRoleReq, AppendUserRoleRsp, AuthAccessReq, AuthAccessRsp, CancelBoardConfigReq, CancelBoardConfigRsp, CancelCommonTabReq, CancelCommonTabRsp, CheckUserOnJobStatusReq, CheckUserOnJobStatusRsp, ColumnInfoReq, ColumnInfoRsp, CommonOperationRsp, ConfigLogExportReq, ConfigLogExportRsp, ConfigOpQueryCSVRsp, ConfigOpQueryReq, ConfigOpQueryRsp, CopyAlarmConfigReq, CopyCommonTabReq, CopyCommonTabRsp, CopyComplaintConfReq, CopyComplaintConfRsp, CopyLinkageRuleConfigReq, CopyLinkageRuleConfigRsp, CopyRoleGroupReq, CopyRoleGroupRsp, CsProductQueryReq, CsProductQueryRsp, DelTemplateReq, DelTemplateRsp, EditBoardConfigReq, EditBoardConfigRsp, EditCommonTabReq, EditCommonTabRsp, EditScheduleReq, EditScheduleRsp, ExportAlarmConfigReq, FieldQueryReq, FieldQueryRsp, GetAlarmConfigReq, GetAlarmConfigRsp, GetAlarmDimensionalityReq, GetAlarmDimensionalityRsp, GetAlarmInfoListReq, GetAlarmInfoListRsp, GetAutoRecommendRuleReq, GetAutoRecommendRuleRsp, GetBoardConfigReq, GetBoardConfigRsp, GetCommonTabReq, GetCommonTabRsp, GetComplaintConfReq, GetComplaintConfRsp, GetCustomCategoryReq, GetCustomCategoryRsp, GetCustomFieldByProdsReq, GetCustomFieldByProdsRsp, GetFieldsNameRep, GetFieldsNameRsp, GetFileReq, GetFileRsp, GetGlobalConfigReq, GetGlobalConfigRsp, GetLinkageRuleConfigReq, GetLinkageRuleConfigRsp, GetLinkageRulesReq, GetLinkageRulesRsp, GetMergeOptionsReq, GetMergeOptionsRsp, GetProductByWxworkReq, GetProductByWxworkRsp, GetProjectCommonConfigReq, GetProjectCommonConfigRsp, GetResourceUrlReq, GetResourceUrlRsp, GetSearchFieldsReq, GetSearchFieldsRsp, GetUserCommonTabReq, GetUserCommonTabRsp, GetUserProdInfoReq, GetUserProdInfoRsp, HelperConfigCheckReq, HelperConfigCheckRsp, HelperConfigListReq, HelperConfigListRsp, ImportAlarmConfigReq, ImportAutoRecommendRuleReq, ImportAutoRecommendRuleRsp, ImportOpenSysUserReq, ImportOpenSysUserRsp, ImportScheduleReq, ImportScheduleRsp, MostRecentProjReq, MostRecentProjRsp, NewProductAddRoleReq, NewProductAddRoleRsp, NewProductParseRoleReq, NewProductParseRoleRsp, ProductAddReq, ProductAddRoleReq, ProductAddRoleRsp, ProductAddRsp, ProductBatchDeleteRoleReq, ProductBatchDeleteRoleRsp, ProductBatchEditRoleReq, ProductBatchEditRoleRsp, ProductGetByHelperIDReq, ProductGetByProjReq, ProductGetByProjRsp, ProductGetReq, ProductGetRoleListReq, ProductGetRoleListRsp, ProductGetRsp, ProductImportRoleReq, ProductImportRoleRsp, ProductListReq, ProductListRsp, ProductQueueUpdateReq, ProductQueueUpdateRsp, ProductUpdateReq, ProductUpdateRsp, ProjectIDByServiceIDReq, ProjectIDByServiceIDRsp, ProjListReq, ProjListRsp, QualityAdminListReq, QualityAdminListRsp, QualityAdminUpdateReq, QualityAdminUpdateRsp, QueryFieldsByProdsReq, QueryFieldsByProdsRsp, QueryProdQueueReq, QueryProdQueueRsp, QueryRoleOptionsReq, QueryRoleOptionsRsp, QueryScheduleReq, QueryScheduleRsp, QueryUsersReq, QueryUsersRsp, ReloadAuthSysUserReq, ReloadAuthSysUserRsp, RenameTemplateReq, RenameTemplateRsp, SaveAlarmConfigReq, SaveBoardConfigReq, SaveBoardConfigRsp, SaveCommonTabReq, SaveCommonTabRsp, SaveComplaintConfReq, SaveComplaintConfRsp, SaveFieldsReq, SaveFieldsRsp, SaveLinkageRuleConfigReq, SaveLinkageRuleConfigRsp, SaveUserCommonTabReq, SaveUserCommonTabRsp, SaveUserProdInfoReq, SaveUserProdInfoRsp, ScheduleInfoReq, ScheduleInfoRsp, ScheduleQueryCSVRsp, ScheduleQueryReq, ScheduleQueryRsp, SearchFieldsReq, SearchFieldsRsp, SearchOptionsReq, SearchOptionsRsp, SwitchAlarmStatusReq, SwitchAlarmStatusRsp, SyncToOtherProdReq, SyncToOtherProdRsp, T2000QueryRsp, TcloudproddirGetReq, TcloudproddirGetRsp, TemplateDetailReq, TemplateDetailRsp, TemplateListReq, TemplateListRsp, UnAuthAccessReq, UnAuthAccessRsp, UpdateAuthAccessRsp, UpdateScheduleReq, UpdateScheduleRsp, UpdateSearchColumnsReq, UpdateSearchColumnsRsp, UpdateSearchFieldsReq, UpdateSearchFieldsRsp, UpdateSortOrdersReq, UploadFileReq, UploadFileRsp, UploadLinkageRulesReq, UploadLinkageRulesRsp, UserInProjectReq, UserInProjectRsp, UserProfileReq, UserProfileRsp, UserRoleCheckReq, UserRoleCheckRsp, UserRoleQueryCSVRsp, UserRoleQueryReq, UserRoleQueryRsp } from "./product_without_validate_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * 定义service rpc方法，一个server可以有多个service，一般都是一个server一个service
 *
 * @generated from service trpc.teg_devops.servicedesk_product.Product
 */
export const Product = {
  typeName: "trpc.teg_devops.servicedesk_product.Product",
  methods: {
    /**
     * 查询产品列表
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductList
     */
    productList: {
      name: "ProductList",
      I: ProductListReq,
      O: ProductListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UserProfile
     */
    userProfile: {
      name: "UserProfile",
      I: UserProfileReq,
      O: UserProfileRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductGetByProj
     */
    productGetByProj: {
      name: "ProductGetByProj",
      I: ProductGetByProjReq,
      O: ProductGetByProjRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取项目列表
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProjList
     */
    projList: {
      name: "ProjList",
      I: ProjListReq,
      O: ProjListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 记录最新访问的项目
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.MostRecentProj
     */
    mostRecentProj: {
      name: "MostRecentProj",
      I: MostRecentProjReq,
      O: MostRecentProjRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取0线（客服产品）
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CsProductQuery
     */
    csProductQuery: {
      name: "CsProductQuery",
      I: CsProductQueryReq,
      O: CsProductQueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取T2000的产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.T2000Query
     */
    t2000Query: {
      name: "T2000Query",
      I: CsProductQueryReq,
      O: T2000QueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductGet
     */
    productGet: {
      name: "ProductGet",
      I: ProductGetReq,
      O: ProductGetRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 检查用户角色
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UserRoleCheck
     */
    userRoleCheck: {
      name: "UserRoleCheck",
      I: UserRoleCheckReq,
      O: UserRoleCheckRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取腾讯云产品目录信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.TcloudproddirGet
     */
    tcloudproddirGet: {
      name: "TcloudproddirGet",
      I: TcloudproddirGetReq,
      O: TcloudproddirGetRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 更新产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductUpdate
     */
    productUpdate: {
      name: "ProductUpdate",
      I: ProductUpdateReq,
      O: ProductUpdateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 新增产品
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductAdd
     */
    productAdd: {
      name: "ProductAdd",
      I: ProductAddReq,
      O: ProductAddRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 更新产品队列信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductQueueUpdate
     */
    productQueueUpdate: {
      name: "ProductQueueUpdate",
      I: ProductQueueUpdateReq,
      O: ProductQueueUpdateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveFields
     */
    saveFields: {
      name: "SaveFields",
      I: SaveFieldsReq,
      O: SaveFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveFieldsSortNo
     */
    saveFieldsSortNo: {
      name: "SaveFieldsSortNo",
      I: SaveFieldsReq,
      O: SaveFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.EnableDisableFields
     */
    enableDisableFields: {
      name: "EnableDisableFields",
      I: SaveFieldsReq,
      O: SaveFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ColumnInfo
     */
    columnInfo: {
      name: "ColumnInfo",
      I: ColumnInfoReq,
      O: ColumnInfoRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.FieldQuery
     */
    fieldQuery: {
      name: "FieldQuery",
      I: FieldQueryReq,
      O: FieldQueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SyncToOtherProd
     */
    syncToOtherProd: {
      name: "SyncToOtherProd",
      I: SyncToOtherProdReq,
      O: SyncToOtherProdRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 修改排班
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UpdateSchedule
     */
    updateSchedule: {
      name: "UpdateSchedule",
      I: UpdateScheduleReq,
      O: UpdateScheduleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询排班
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QuerySchedule
     */
    querySchedule: {
      name: "QuerySchedule",
      I: QueryScheduleReq,
      O: QueryScheduleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProjectIDByServiceID
     */
    projectIDByServiceID: {
      name: "ProjectIDByServiceID",
      I: ProjectIDByServiceIDReq,
      O: ProjectIDByServiceIDRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QualityAdminList
     */
    qualityAdminList: {
      name: "QualityAdminList",
      I: QualityAdminListReq,
      O: QualityAdminListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QualityAdminUpdate
     */
    qualityAdminUpdate: {
      name: "QualityAdminUpdate",
      I: QualityAdminUpdateReq,
      O: QualityAdminUpdateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.HelperConfigCheck
     */
    helperConfigCheck: {
      name: "HelperConfigCheck",
      I: HelperConfigCheckReq,
      O: HelperConfigCheckRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.HelperConfigList
     */
    helperConfigList: {
      name: "HelperConfigList",
      I: HelperConfigListReq,
      O: HelperConfigListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UploadFile
     */
    uploadFile: {
      name: "UploadFile",
      I: UploadFileReq,
      O: UploadFileRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 根据HelperID（serviceid）获取产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductGetByHelperID
     */
    productGetByHelperID: {
      name: "ProductGetByHelperID",
      I: ProductGetByHelperIDReq,
      O: ProductGetRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 资源授权重定向
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetFile
     */
    getFile: {
      name: "GetFile",
      I: GetFileReq,
      O: GetFileRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 新建产品后新增人员
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.NewProductAddRole
     */
    newProductAddRole: {
      name: "NewProductAddRole",
      I: NewProductAddRoleReq,
      O: NewProductAddRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 人员配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductAddRole
     */
    productAddRole: {
      name: "ProductAddRole",
      I: ProductAddRoleReq,
      O: ProductAddRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     *  rpc ProductDeleteRole(ProductDeleteRoleReq) returns (ProductDeleteRoleRsp){}
     *  rpc ProductEditRole(ProductEditRoleReq) returns (ProductEditRoleRsp){}
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UserRoleQuery
     */
    userRoleQuery: {
      name: "UserRoleQuery",
      I: UserRoleQueryReq,
      O: UserRoleQueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UserRoleQueryCSV
     */
    userRoleQueryCSV: {
      name: "UserRoleQueryCSV",
      I: UserRoleQueryReq,
      O: UserRoleQueryCSVRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductImportRole
     */
    productImportRole: {
      name: "ProductImportRole",
      I: ProductImportRoleReq,
      O: ProductImportRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.NewProductParseRole
     */
    newProductParseRole: {
      name: "NewProductParseRole",
      I: NewProductParseRoleReq,
      O: NewProductParseRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductBatchEditRole
     */
    productBatchEditRole: {
      name: "ProductBatchEditRole",
      I: ProductBatchEditRoleReq,
      O: ProductBatchEditRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductBatchDeleteRole
     */
    productBatchDeleteRole: {
      name: "ProductBatchDeleteRole",
      I: ProductBatchDeleteRoleReq,
      O: ProductBatchDeleteRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 安灯派单配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ScheduleInfo
     */
    scheduleInfo: {
      name: "ScheduleInfo",
      I: ScheduleInfoReq,
      O: ScheduleInfoRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ScheduleQuery
     */
    scheduleQuery: {
      name: "ScheduleQuery",
      I: ScheduleQueryReq,
      O: ScheduleQueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ScheduleQueryCSV
     */
    scheduleQueryCSV: {
      name: "ScheduleQueryCSV",
      I: ScheduleQueryReq,
      O: ScheduleQueryCSVRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.AddSchedule
     */
    addSchedule: {
      name: "AddSchedule",
      I: AddScheduleReq,
      O: AddScheduleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.EditSchedule
     */
    editSchedule: {
      name: "EditSchedule",
      I: EditScheduleReq,
      O: EditScheduleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ImportSchedule
     */
    importSchedule: {
      name: "ImportSchedule",
      I: ImportScheduleReq,
      O: ImportScheduleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 操作日志
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ConfigOpQuery
     */
    configOpQuery: {
      name: "ConfigOpQuery",
      I: ConfigOpQueryReq,
      O: ConfigOpQueryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ConfigOpQueryCSV
     */
    configOpQueryCSV: {
      name: "ConfigOpQueryCSV",
      I: ConfigOpQueryReq,
      O: ConfigOpQueryCSVRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ConfigLogExport
     */
    configLogExport: {
      name: "ConfigLogExport",
      I: ConfigLogExportReq,
      O: ConfigLogExportRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询个人视图列表
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.TemplateList
     */
    templateList: {
      name: "TemplateList",
      I: TemplateListReq,
      O: TemplateListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询视图详情
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.TemplateDetail
     */
    templateDetail: {
      name: "TemplateDetail",
      I: TemplateDetailReq,
      O: TemplateDetailRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 修改视图名字
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.RenameTemplate
     */
    renameTemplate: {
      name: "RenameTemplate",
      I: RenameTemplateReq,
      O: RenameTemplateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 添加视图
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.AddTemplate
     */
    addTemplate: {
      name: "AddTemplate",
      I: AddTemplateRep,
      O: AddTemplateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存当前视图
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveTemplate
     */
    saveTemplate: {
      name: "SaveTemplate",
      I: AddTemplateRep,
      O: AddTemplateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 删除视图(逻辑删除)
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.DelTemplate
     */
    delTemplate: {
      name: "DelTemplate",
      I: DelTemplateReq,
      O: DelTemplateRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取一个或多个产品下自定义字段
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetCustomFieldByProds
     */
    getCustomFieldByProds: {
      name: "GetCustomFieldByProds",
      I: GetCustomFieldByProdsReq,
      O: GetCustomFieldByProdsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 搜索界面所有字段查询
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetSearchFields
     */
    getSearchFields: {
      name: "GetSearchFields",
      I: GetSearchFieldsReq,
      O: GetSearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 视图界面查询
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetSearchResultColumns
     */
    getSearchResultColumns: {
      name: "GetSearchResultColumns",
      I: GetSearchFieldsReq,
      O: GetSearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 更新字段, 被弃用
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UpdateSearchFields
     */
    updateSearchFields: {
      name: "UpdateSearchFields",
      I: UpdateSearchFieldsReq,
      O: UpdateSearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 更新视图界面用户选择的列，被弃用
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UpdateSearchColumns
     */
    updateSearchColumns: {
      name: "UpdateSearchColumns",
      I: UpdateSearchColumnsReq,
      O: UpdateSearchColumnsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 修改列排序值
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UpdateSortOrders
     */
    updateSortOrders: {
      name: "UpdateSortOrders",
      I: UpdateSortOrdersReq,
      O: UpdateSearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询字段名称
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetFieldsName
     */
    getFieldsName: {
      name: "GetFieldsName",
      I: GetFieldsNameRep,
      O: GetFieldsNameRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询告警信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetAlarmInfoList
     */
    getAlarmInfoList: {
      name: "GetAlarmInfoList",
      I: GetAlarmInfoListReq,
      O: GetAlarmInfoListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 动态获取要合并的下拉选项和级联数据
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetMergeOptions
     */
    getMergeOptions: {
      name: "GetMergeOptions",
      I: GetMergeOptionsReq,
      O: GetMergeOptionsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetAllSearchFields
     */
    getAllSearchFields: {
      name: "GetAllSearchFields",
      I: GetSearchFieldsReq,
      O: GetSearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QueryFieldsByProds
     */
    queryFieldsByProds: {
      name: "QueryFieldsByProds",
      I: QueryFieldsByProdsReq,
      O: QueryFieldsByProdsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取资源路径
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetResourceUrl
     */
    getResourceUrl: {
      name: "GetResourceUrl",
      I: GetResourceUrlReq,
      O: GetResourceUrlRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取项目下的所有角色列表
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ProductGetRoleList
     */
    productGetRoleList: {
      name: "ProductGetRoleList",
      I: ProductGetRoleListReq,
      O: ProductGetRoleListRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取产品告警配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetAlarmConfig
     */
    getAlarmConfig: {
      name: "GetAlarmConfig",
      I: GetAlarmConfigReq,
      O: GetAlarmConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 修改产品告警状态
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SwitchAlarmStatus
     */
    switchAlarmStatus: {
      name: "SwitchAlarmStatus",
      I: SwitchAlarmStatusReq,
      O: SwitchAlarmStatusRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 校验人员在职状态
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CheckUserOnJobStatus
     */
    checkUserOnJobStatus: {
      name: "CheckUserOnJobStatus",
      I: CheckUserOnJobStatusReq,
      O: CheckUserOnJobStatusRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存人员上次选择产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveUserProdInfo
     */
    saveUserProdInfo: {
      name: "SaveUserProdInfo",
      I: SaveUserProdInfoReq,
      O: SaveUserProdInfoRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取人员上次选择产品信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetUserProdInfo
     */
    getUserProdInfo: {
      name: "GetUserProdInfo",
      I: GetUserProdInfoReq,
      O: GetUserProdInfoRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取产品告警维度
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetAlarmDimensionality
     */
    getAlarmDimensionality: {
      name: "GetAlarmDimensionality",
      I: GetAlarmDimensionalityReq,
      O: GetAlarmDimensionalityRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存产品告警配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveAlarmConfig
     */
    saveAlarmConfig: {
      name: "SaveAlarmConfig",
      I: SaveAlarmConfigReq,
      O: CommonOperationRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 复制产品告警配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CopyAlarmConfig
     */
    copyAlarmConfig: {
      name: "CopyAlarmConfig",
      I: CopyAlarmConfigReq,
      O: CommonOperationRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 导出产品告警配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ExportAlarmConfig
     */
    exportAlarmConfig: {
      name: "ExportAlarmConfig",
      I: ExportAlarmConfigReq,
      O: CommonOperationRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 导入产品告警配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ImportAlarmConfig
     */
    importAlarmConfig: {
      name: "ImportAlarmConfig",
      I: ImportAlarmConfigReq,
      O: CommonOperationRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 覆盖产品角色组信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CopyRoleGroup
     */
    copyRoleGroup: {
      name: "CopyRoleGroup",
      I: CopyRoleGroupReq,
      O: CopyRoleGroupRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 追加人员角色信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.AppendUserRole
     */
    appendUserRole: {
      name: "AppendUserRole",
      I: AppendUserRoleReq,
      O: AppendUserRoleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 查询搜索字段信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SearchFields
     */
    searchFields: {
      name: "SearchFields",
      I: SearchFieldsReq,
      O: SearchFieldsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取全局的一些配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetGlobalConfig
     */
    getGlobalConfig: {
      name: "GetGlobalConfig",
      I: GetGlobalConfigReq,
      O: GetGlobalConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取项目下通用配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetProjectCommonConfig
     */
    getProjectCommonConfig: {
      name: "GetProjectCommonConfig",
      I: GetProjectCommonConfigReq,
      O: GetProjectCommonConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取看板配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetBoardConfig
     */
    getBoardConfig: {
      name: "GetBoardConfig",
      I: GetBoardConfigReq,
      O: GetBoardConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存看板配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveBoardConfig
     */
    saveBoardConfig: {
      name: "SaveBoardConfig",
      I: SaveBoardConfigReq,
      O: SaveBoardConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 编辑校验
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.EditBoardConfig
     */
    editBoardConfig: {
      name: "EditBoardConfig",
      I: EditBoardConfigReq,
      O: EditBoardConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 取消编辑
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CancelBoardConfig
     */
    cancelBoardConfig: {
      name: "CancelBoardConfig",
      I: CancelBoardConfigReq,
      O: CancelBoardConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取项目下全部已接入企业微信渠道的产品
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetProductByWxwork
     */
    getProductByWxwork: {
      name: "GetProductByWxwork",
      I: GetProductByWxworkReq,
      O: GetProductByWxworkRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取自定义字段分类
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetCustomCategory
     */
    getCustomCategory: {
      name: "GetCustomCategory",
      I: GetCustomCategoryReq,
      O: GetCustomCategoryRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveCommonTab
     */
    saveCommonTab: {
      name: "SaveCommonTab",
      I: SaveCommonTabReq,
      O: SaveCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetCommonTab
     */
    getCommonTab: {
      name: "GetCommonTab",
      I: GetCommonTabReq,
      O: GetCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 编辑自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.EditCommonTab
     */
    editCommonTab: {
      name: "EditCommonTab",
      I: EditCommonTabReq,
      O: EditCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 取消编辑自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CancelCommonTab
     */
    cancelCommonTab: {
      name: "CancelCommonTab",
      I: CancelCommonTabReq,
      O: CancelCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 复制TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CopyCommonTab
     */
    copyCommonTab: {
      name: "CopyCommonTab",
      I: CopyCommonTabReq,
      O: CopyCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 用户维度获取自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetUserCommonTab
     */
    getUserCommonTab: {
      name: "GetUserCommonTab",
      I: GetUserCommonTabReq,
      O: GetUserCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 用户维度保存自定义TAB配置
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveUserCommonTab
     */
    saveUserCommonTab: {
      name: "SaveUserCommonTab",
      I: SaveUserCommonTabReq,
      O: SaveUserCommonTabRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 校验用户是否在项目下
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UserInProject
     */
    userInProject: {
      name: "UserInProject",
      I: UserInProjectReq,
      O: UserInProjectRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取全部字段联动规则
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetLinkageRules
     */
    getLinkageRules: {
      name: "GetLinkageRules",
      I: GetLinkageRulesReq,
      O: GetLinkageRulesRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 导入联动规则excel表
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UploadLinkageRules
     */
    uploadLinkageRules: {
      name: "UploadLinkageRules",
      I: UploadLinkageRulesReq,
      O: UploadLinkageRulesRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 添加OpenApi授权用户
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.AuthAccess
     */
    authAccess: {
      name: "AuthAccess",
      I: AuthAccessReq,
      O: AuthAccessRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 取消OpenApi授权用户
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UnAuthAccess
     */
    unAuthAccess: {
      name: "UnAuthAccess",
      I: UnAuthAccessReq,
      O: UnAuthAccessRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 修改OpenApi授权用户
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.UpdateAuthAccess
     */
    updateAuthAccess: {
      name: "UpdateAuthAccess",
      I: AuthAccessReq,
      O: UpdateAuthAccessRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 重刷权限信息到服务
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ReloadAuthSysUser
     */
    reloadAuthSysUser: {
      name: "ReloadAuthSysUser",
      I: ReloadAuthSysUserReq,
      O: ReloadAuthSysUserRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 复制字段联动规则
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CopyLinkageRuleConfig
     */
    copyLinkageRuleConfig: {
      name: "CopyLinkageRuleConfig",
      I: CopyLinkageRuleConfigReq,
      O: CopyLinkageRuleConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 根据字段获取字段联动规则
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetLinkageRuleConfig
     */
    getLinkageRuleConfig: {
      name: "GetLinkageRuleConfig",
      I: GetLinkageRuleConfigReq,
      O: GetLinkageRuleConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存字段联动规则:局部更新
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveLinkageRuleConfig
     */
    saveLinkageRuleConfig: {
      name: "SaveLinkageRuleConfig",
      I: SaveLinkageRuleConfigReq,
      O: SaveLinkageRuleConfigRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 导入自动推荐队列/技能组规则
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ImportAutoRecommendRule
     */
    importAutoRecommendRule: {
      name: "ImportAutoRecommendRule",
      I: ImportAutoRecommendRuleReq,
      O: ImportAutoRecommendRuleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取自动推荐队列/技能组规则
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetAutoRecommendRule
     */
    getAutoRecommendRule: {
      name: "GetAutoRecommendRule",
      I: GetAutoRecommendRuleReq,
      O: GetAutoRecommendRuleRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 获取投诉配置信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.GetComplaintConf
     */
    getComplaintConf: {
      name: "GetComplaintConf",
      I: GetComplaintConfReq,
      O: GetComplaintConfRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 保存投诉配置信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SaveComplaintConf
     */
    saveComplaintConf: {
      name: "SaveComplaintConf",
      I: SaveComplaintConfReq,
      O: SaveComplaintConfRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 复制投诉配置信息
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.CopyComplaintConf
     */
    copyComplaintConf: {
      name: "CopyComplaintConf",
      I: CopyComplaintConfReq,
      O: CopyComplaintConfRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 根据字段和用户输入的选项关键字，返回符合条件的选项
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.SearchOptions
     */
    searchOptions: {
      name: "SearchOptions",
      I: SearchOptionsReq,
      O: SearchOptionsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QueryRoleOptions
     */
    queryRoleOptions: {
      name: "QueryRoleOptions",
      I: QueryRoleOptionsReq,
      O: QueryRoleOptionsRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QueryUsers
     */
    queryUsers: {
      name: "QueryUsers",
      I: QueryUsersReq,
      O: QueryUsersRsp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.QueryProdQueue
     */
    queryProdQueue: {
      name: "QueryProdQueue",
      I: QueryProdQueueReq,
      O: QueryProdQueueRsp,
      kind: MethodKind.Unary,
    },
    /**
     * 导入生成open账号
     *
     * @generated from rpc trpc.teg_devops.servicedesk_product.Product.ImportOpenSysUser
     */
    importOpenSysUser: {
      name: "ImportOpenSysUser",
      I: ImportOpenSysUserReq,
      O: ImportOpenSysUserRsp,
      kind: MethodKind.Unary,
    },
  }
} as const;

